<template>
  <div class="user container box">
    <Ad1/>
    <div class="tabBtn">
      <a v-bind:class="{active:tab==0}" @click="changeTab(0)">獲得コイン</a>
      <a v-bind:class="{active:tab==1}" @click="changeTab(1)">出金/設定</a>
    </div>
    <div class="tabBox">
      <div v-if="tab==0" class="tab">
        <dl>
          <dt>ログイン中のユーザーネーム1</dt>
          <dd>{{displayName}}</dd>
        </dl>
        <dl>
          <dt>獲得したコイン</dt>
          <dd>
            {{hasCoin}} satoshi
            <!--<p class="info">-->
            <!--  現在付与処理に問題が発生しております。<br>-->
            <!--  後日付与されますのでご安心ください。-->
            <!--</p>-->
          </dd>
        </dl>
      </div>
      <div v-if="tab==1" class="tab">
        <h3>出金</h3>
        <dl>
          <dt>所有コイン</dt>
          <dd>{{hasCoin}} satoshi</dd>
        </dl>
        <dl>
          <dt>引き出し可能なコイン</dt>
          <dd>{{Math.max(0, hasCoin - 3000)}} satoshi</dd>
        </dl>
        <dl>
          <dt>送金先ビットコインアドレス</dt>
          <dd><input v-model="address" placeholder="ビットコインアドレスを入力" type="text" name=""/></dd>
        </dl>
        <dl>
          <dt>引き出すビットコイン</dt>
          <dd><input v-model="withdrawAmount" name=""/></dd>
        </dl>
        <p class="info">{{alertMessage}}</p>
        <a @click="withdraw" v-if="this.alertMessage==''" class="btn">
          送金申請する
        </a>
        <h3>設定</h3>
        <dl>
          <dt>ユーザーネーム</dt>
          <dd><input type="text" v-model="newDisplayName" placeholder="名無しさん"></dd>
        </dl>
        <a @click="updateName" class="btn">
          {{changeNameBtn}}
        </a>
      </div>
    </div>
    <div class="ad">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+49LWEA+50+4T0KE9" target="_blank" rel="nofollow">
      <img border="0" width="125" height="125" alt="" src="https://www23.a8.net/svt/bgt?aid=181213493258&wid=003&eno=01&mid=s00000000018029060000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www18.a8.net/0.gif?a8mat=2ZW185+49LWEA+50+4T0KE9" alt="">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+49LWEA+50+4T0S41" target="_blank" rel="nofollow">
      <img border="0" width="125" height="125" alt="" src="https://www25.a8.net/svt/bgt?aid=181213493258&wid=003&eno=01&mid=s00000000018029061000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www16.a8.net/0.gif?a8mat=2ZW185+49LWEA+50+4T0S41" alt="">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+49LWEA+50+4T0KE9" target="_blank" rel="nofollow">
      <img border="0" width="125" height="125" alt="" src="https://www23.a8.net/svt/bgt?aid=181213493258&wid=003&eno=01&mid=s00000000018029060000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www18.a8.net/0.gif?a8mat=2ZW185+49LWEA+50+4T0KE9" alt="">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+49LWEA+50+4T0S41" target="_blank" rel="nofollow">
      <img border="0" width="125" height="125" alt="" src="https://www25.a8.net/svt/bgt?aid=181213493258&wid=003&eno=01&mid=s00000000018029061000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www16.a8.net/0.gif?a8mat=2ZW185+49LWEA+50+4T0S41" alt="">
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import Ad1 from './ad/Ad1'

export default {
  name: 'User',
  components: {
    Ad1
  },
  data () {
    return {
      user: null,
      displayName: '',
      newDisplayName: '',
      hasCoin: 0,
      firestore: null,
      tab: 0,
      withdrawAmount: 0,
      alertMessage: '',
      changeNameBtn: '変更',
      address: ''
    }
  },
  created: function () {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.firestore = firebase.firestore()
        this.firestore.settings({ timestampsInSnapshots: true })
        this.user = user
        this.displayName = user.displayName
        this.newDisplayName = user.displayName
        this.firestore.collection('users').doc(user.uid).get().then(doc => {
          console.log(doc.data())
          this.hasCoin = doc.data().satoshi
          this.withdrawAmount = doc.data().satoshi
        })
      } else {
      }
    })
  },
  methods: {
    changeTab: function (_id) {
      this.tab = _id
    },
    withdraw: function () {
      var withdrawFnc = firebase.functions().httpsCallable('withdraw')
      withdrawFnc({address: this.address, amount: this.withdrawAmount}).then(result => {
        alert('出金申請が完了しました。')
      }).catch(e => {
        alert('不明なエラー。お問い合わせよりご連絡ください。')
      })
    },
    updateName: function () {
      if (this.newDisplayName === '') this.newDisplayName = '名無しさん'
      firebase.auth().currentUser.updateProfile({displayName: this.newDisplayName}).then(() => {
        this.displayName = this.newDisplayName
        this.changeNameBtn = '変更されました'
        setTimeout(() => {
          this.changeNameBtn = '更新'
        }, 1500)
      })
    }
  },
  watch: {
    withdrawAmount: function (val) {
      if (val > this.hasCoin) {
        this.alertMessage = '出金可能額を超えています。'
      } else if (val < 3000) {
        this.alertMessage = '3000 satosi から引き出し可能です。'
      } else if (this.address === '') {
        this.alertMessage = 'ビットコインアドレスを入力してください。'
      } else {
        this.alertMessage = ''
      }
    },
    address: function (val) {
      if (this.withdrawAmount > this.hasCoin - 3000) {
        this.alertMessage = '出金可能額を超えています。'
      } else if (this.withdrawAmount < 3000) {
        this.alertMessage = '3000 satosi から引き出し可能です。'
      } else if (val === '') {
        this.alertMessage = 'ビットコインアドレスを入力してください。'
      } else {
        this.alertMessage = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.user{
  text-align: center;
}
dl{
  font-size: 20px;
}
dt{
  color: #999;
}
dd{
  font-weight: bold;
  color: #333;
  margin: 0;
}
dd > input{
  width:100%;
  max-width: 600px;
  height: 40px;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  background: #F4F4F4;
  border: none;
}
.tabBtn{
  width: 100%;
  max-width: 624px;
  display: flex;
  margin: 0 auto;
  background: #B5E8EF;
  margin-top: 20px;
}
.tabBtn a{
  width: 50%;
  height: 60px;
  text-align: center;
  display: block;
  line-height: 60px;
  cursor: pointer;
}
.tabBtn .active{
  background: #02BAD2;
}
.info{
  color: #F44100;
  font-size: 20px;
}
.btn{
  background: #02BAD2;
  color: #fff;
  width: 100%;
  max-width: 360px;
  height: 60px;
  border-radius: 30px;
  line-height: 60px;
  margin: 0 auto;
  font-weight: bold;
  display: block;
  cursor: pointer;
  margin-bottom: 20px;
}
@media all and (max-width: 480px) {
  .tabBtn{
    width: 90%;
  }
  .tabBtn a{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  dt{
    font-size: 14px;
  }
  dd{
    font-size: 16px;
  }
  dd input{
    width: 90%;
    font-size: 14px;
    height: 30px;
  }
  .info{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue